export const SITE_URL = 'https://ai.psyhelp.info';
export const SITE_NAME = 'AI PSY HELP';
export const LEGAL_NAME = 'MPT PAY LTD';
export const LEGAL_NAME_REGISTERED = 'MPT PAY LIMITED';
export const BRAND_NAME = 'AI PSY HELP';
export const CONTROLLER_ROLE = 'Data controller for the website, mobile applications and related wellbeing services';
export const COMPANY_NUMBER = '11674181';
export const REGISTERED_COUNTRY = 'United Kingdom';
export const REGISTERED_ADDRESS = '71-75 Shelton Street, Covent Garden, London, United Kingdom, WC2H 9JQ';
export const COMPANIES_HOUSE_URL = 'https://find-and-update.company-information.service.gov.uk/company/11674181';
export const HOSTING_REGION = 'Microsoft Azure servers in the EU';
export const CONTACT_EMAIL = 'ai@psyhelp.info';
export const DPO_EMAIL = 'dpo@psyhelp.info';
export const SUPPORT_EMAIL = 'ai@psyhelp.info';

/** Ukrainian NGO behind social programs (Google Ad Grants / public mission page). */
export const NGO_NAME_UK = 'ГО «ПСАЙХЕЛП»';
export const NGO_NAME_EN = 'NGO PSY HELP';
export const NGO_EDRPOU = '45900321';
export const NGO_REGISTERED_DATE = '17.12.2024';
export const NGO_CONTACT_EMAIL = 'ai@psyhelp.info';
export const NGO_FACEBOOK = 'https://www.facebook.com/PsyHelpUA/';
export const PRIVACY_VERSION = '2026-08-16';
export const TERMS_VERSION = '2026-08-16';
export const COOKIES_VERSION = '2026-08-16';
export const CLINICAL_POLICY_VERSION = '2026-08-16';
export const DOCUMENT_EFFECTIVE_ISO = '2026-08-16';

export const SAME_AS = [
  'https://www.linkedin.com/company/aipsyhelp',
  'https://www.facebook.com/PsyHelpUA/',
  'https://www.youtube.com/@AIPSYHELP',
  'https://www.tiktok.com/@ai.psy.help',
  'https://apps.apple.com/app/id6748014564',
  'https://play.google.com/store/apps/details?id=com.aipsyhelp.app'
];

export const LANGUAGES = ['en', 'uk', 'de', 'lt'];

export const PUBLIC_ROUTES = [
  '',
  '/news',
  '/videos',
  '/corporate',
  '/ngo',
  '/webinars',
  '/privacy',
  '/privacy-policy',
  '/terms',
  '/terms-of-use',
  '/cookies',
  '/clinical-safety',
  '/editorial-policy',
  '/team',
  '/research',
  '/security',
  '/ai-wellbeing',
  '/social-mission',
  '/account-deletion',
  '/for-specialists'
];

export const NOINDEX_PATHS = [
  '/login',
  '/register',
  '/profile',
  '/dashboard',
  '/admin'
];

export const VENDORS = [
  {
    id: 'azure',
    name: 'Microsoft Azure',
    purpose: 'Hosting, application backend, encrypted storage',
    category: 'essential',
    region: 'EU',
    retention: 'For the life of the service plus legal retention'
  },
  {
    id: 'apple',
    name: 'Apple App Store',
    purpose: 'iOS distribution and in-app subscription billing',
    category: 'essential',
    region: 'Processor per Apple terms',
    retention: 'Subscription status for the billing relationship'
  },
  {
    id: 'google-play',
    name: 'Google Play',
    purpose: 'Android distribution and in-app subscription billing',
    category: 'essential',
    region: 'Processor per Google terms',
    retention: 'Subscription status for the billing relationship'
  },
  {
    id: 'stripe',
    name: 'Stripe',
    purpose: 'Optional web / B2B payment processing when not billed via app stores',
    category: 'essential',
    region: 'Processor per Stripe DPA',
    retention: 'Transaction records as required by financial law'
  },
  {
    id: 'gtm',
    name: 'Google Tag Manager (GTM-K923GBB8)',
    purpose: 'Tag management under Consent Mode v2',
    category: 'analytics',
    region: 'USA / EU SCCs via Google',
    retention: 'No cookie before grant; storage-based tags fire only after grant'
  },
  {
    id: 'ga4',
    name: 'Google Analytics 4 (G-FZH7LJLTSJ)',
    purpose: 'Aggregated website measurement; cookieless pings before consent',
    category: 'analytics',
    region: 'USA / EU SCCs via Google',
    retention: '14 months unless shortened in GA4'
  },
  {
    id: 'clarity',
    name: 'Microsoft Clarity',
    purpose: 'Session diagnostics after analytics consent',
    category: 'analytics',
    region: 'USA / EU SCCs via Microsoft',
    retention: 'Per Microsoft Clarity default, max 13 months'
  },
  {
    id: 'google-ads',
    name: 'Google Ads',
    purpose: 'Conversion measurement and advertising after advertising consent',
    category: 'advertising',
    region: 'USA / EU SCCs via Google',
    retention: 'Until consent withdrawn'
  }
];

export function localizedPath(path, language) {
  const clean = path === '/' ? '' : path;
  return `/${language}${clean}`;
}

export function absoluteUrl(path, language) {
  return `${SITE_URL}${localizedPath(path, language)}`;
}
